import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SneAnswerService } from '../services/sne-answer.service';
import { getResolvedUrl, validatePath } from './guard.helpers';
import { CPS_ASSESSMENT_LIST } from '../sne-v2/sne-v2.helpers';
import {
  generateNextQuestionPath
} from '../sne-v2/collaborative-problem-solving-v2/sne-collaborative-problem-solving.helpers';

@Injectable({
  providedIn: 'root'
})
export class SneCpsCompleteGuard implements CanActivateChild {
  constructor(private sneAnswerService: SneAnswerService) {}

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const currentPath = getResolvedUrl(childRoute);
    return this.sneAnswerService.getSneAssessmentRecords().pipe(map((assessments): boolean | UrlTree => {
      return validatePath(CPS_ASSESSMENT_LIST, assessments, currentPath, generateNextQuestionPath);
    }));

  }

}
